export default __webpack_public_path__ + "static/media/img3.73107ad1.PNG";